export default __webpack_public_path__ + "static/media/806.1b4b7d86.gif";